import { createFileRoute } from "@tanstack/react-router";
import ClubRegister from "@/pages/ClubRegister";

export const Route = createFileRoute("/club-register")({
  head: () => ({
    meta: [
      { title: "Club registreren | De Hussel App" },
      { name: "description", content: "Registreer je tennisclub voor De Hussel App. Automatische hussel-indelingen voor je club. Vanaf €19,95 per maand." },
      { property: "og:title", content: "Club registreren | De Hussel App" },
      { property: "og:description", content: "Registreer je tennisclub voor De Hussel App. Automatische hussel-indelingen voor je club. Vanaf €19,95 per maand." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/club-register" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/club-register" }],
  }),
  component: ClubRegister,
});
